import { actionTypes } from 'BASE/store/types';
import chatUtil from 'BASE/common/chat/chat.util';
import chatConstant from 'BASE/common/chat/chat.constant';
import CONSTANT from 'BASE/common/chat/chat.constant'
import marquee_component from 'SKYXH/views/Marquee'
import downloadCenter_component from 'SKYXH/views/Home/DownloadCenter';
import switchUrl_component from 'SKYXH/views/SpeedTest/SwitchUrl';
import userFeedback_component from 'SKYXH/views/Feedback';
import GoExternalGame from 'BASE/components/externalGame/externalGame.go.component';
import * as gameMenu from 'BASE/common/menu/menu.game';
import lotteryConstant from 'BASE/common/lotteryConstant';
import topHeaderCollectionComponent from 'SKYXH/views/TopHeader.Collection.vue';
import topHeaderCollectionEditComponent from 'SKYXH/views/TopHeader.CollectionEdit.vue';
import slide_up_down from 'vue-slide-up-down';

import audiovisual from 'BASE/components/audiovisual/audiovisual.component';
export default {
    data: function () {
        return {
            activedTab: undefined,
            gameMenus: {},
            vrMenus: {},
            showTopMenu:true,
            showRightMenu:true,
            foldRightMenu:false,
            activeHomeIcon:false,
        };
    },
    mixins: [GoExternalGame,audiovisual],
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        isAgent(){
            return this.$store.state.userinfo.isAgent;
        },
        isTransferPointEnabled(){
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
        isSuperTransferPointEnabled(){
            return this.$store.state.userinfo.privileges.isSuperTransferPointEnabled;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        nickName() {
            return this.$store.state.userinfo.nickName;
        },
        playerName(){
            let playerName = this.nickName ? this.nickName : this.userName;
            return playerName;
        },
        walletAmount() {
            return this.$store.state.userinfo.walletAmount;
        },
        systemRoomUnreadCount() {
            if(this.$store.state.chat)
            {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
                if(_room)
                    return _room.unreadCount;
            }
                
            return 0;
        },
        customerServiceRoomUnreadCount() {
            if(this.$store.state.chat)
            {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
                if(_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        hideWalletAmount(){
            return this.$store.state.userinfo.hideWalletAmount;
        },
        audioMuted(){
            return this.$store.state.userinfo.audioMuted;
        },
        isDemoSite(){
            return this.$store.state.userinfo.IsDemoSite;
        },
        unreadAnnouncement() {
            const count = this.$store.state.userinfo.unreadAnnouncement
            if (count > 99) {
                return '99+';
            } else if (count > 0) {
                return count;
            } else {
                return '';
            }
        },
        HeadImage() {
            return this.$store.state.userinfo.headImage;
        },
        getLogoUrl() {
            try {
                let code = parseInt(this.HeadImage);
                if ( !code )
                    return require('SKYXH/assets/images/touxiang.jpg');
                
                return require('SKYXH/assets/images/face' + code + '.jpg');
            } catch (e) {
                console.log(e);
                return;
            }
        },
    },
    components: {
        marquee_component,
        downloadCenter_component,
        switchUrl_component,
        userFeedback_component,
        topHeaderCollectionComponent,
        topHeaderCollectionEditComponent,
        slide_up_down,
    },
    methods: {
        clickTab(newTab) {
            if (newTab === this.activedTab) {
                this.closeTab();
                return;
            }
            this.activedTab = newTab;
        },
        closeTab(){
            this.activedTab = undefined;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        },
        openCustomerServiceChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.CUSTOMER_SERVICE, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        openSystemChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.SYSTEM, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        showAnnouncement(id, index) {
            if(this.$parent && this.$parent.showAnnouncement)
            {
                this.$parent.showAnnouncement(id, index);
            }
        },
        showDownloadCenter() {
            if(this.$refs && this.$refs.DownloadCenter)
            {
                this.$refs.DownloadCenter.showDownloadCenter();
            }
        },
        showSwitchUrl() {
            let _this = this;
            let _dialog = _this.$dialog.get('SwitchUrl');
            if (_this.$refs && _this.$refs.SwitchUrlRetest) {
                _this.$refs.SwitchUrlRetest.retest();
            }
            _dialog.show();

            _dialog.$on('close', function () {
                _dialog.hide();
            });
        },
        showFeedback() {
            if(this.$refs && this.$refs.Feedback)
            {
                this.$refs.Feedback.showFeedback();
            }
        },
        async switchCollectionEdit(enable){
            if(this.$refs && this.$refs.CollectionEdit)
            {
                await this.$refs.CollectionEdit.UpdateCollection();
                this.$refs.CollectionEdit.display = enable;
            }
        },
        async updateCollection(){
            if(this.$refs && this.$refs.Collection)
            {
                await this.$refs.Collection.UpdateCollection();
            }
        },
        switchHideWalletAmount(){
            let _hideWalletAmount = !this.hideWalletAmount;
            this.$store.dispatch(actionTypes.USER_INFO_HIDE_WALLET_AMOUNT, { hideWalletAmount: _hideWalletAmount });
        },
        switchAudioMuted(){
            let _audioMuted = !this.audioMuted;
            this.$store.dispatch(actionTypes.USER_INFO_AUDIO_MUTED, { audioMuted: _audioMuted });
        },
        async getUserHeadImage() {
            let _this = this;
            try {
                let _result = await $.post("/api/AccountCenter/GetHeadImage");
                if (_result && _result.state) {
                    _this.$store.dispatch(actionTypes.USER_INFO_HEAD_IMAGE, { headImage: _result.HeadImage });
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    },
    updated(){
        //等所有Vue的資料更新完才做綁定，彩票遊戲選單是動態產生
        let _this = this;
        $(".topMenuItem").unbind().click(function(){
            _this.closeTab();
        });
    },
    async mounted() {
        try {
            this.gameMenus = await gameMenu.get();
            // 取得VR彩票
            this.vrMenus = await this.getVRLottery();
            await this.getUserHeadImage();
        } catch (err) {
            this.$dialog.warning('加载失败');
        }

        document.addEventListener('click',e => {
            if(!this.$el.contains(e.target)){
                this.closeTab();
             }
         })
    },

    watch:{
        "$route.name": function (val, oldVal) {
            let _this = this;
            _this.showTopMenu = true;
            _this.showRightMenu = true;
            _this.activeHomeIcon = false;
            if(val == "DrawHistory" || val == "Register"){
                _this.showRightMenu = false;
            }
            if(val == "Timeout" || val == "IPRestricted" || val == "ErrorMsg" || val == "LinkFailure" || val == "Offline"){
                _this.showTopMenu = false;
            }
            if(val == "Home"){
                _this.activeHomeIcon = true;
            }
        }
    }
};